import React from 'react'
import { useTheme } from 'styled-components'

import { IconComponent } from '@application/Interfaces/Icons/types'
import { Theme } from '@application/Interfaces/Themes/ThemeType'

export const OceanLCLIcon: IconComponent = ({ className, colorCode = 'p500', width = 50, height = 50 }) => {
    const theme = useTheme() as Theme
    const color = theme.color[colorCode]

    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 192 192"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <style>{`.cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:7.00px;}.cls-1{stroke:#FF4D00;}.cls-2{stroke:${color};}`}</style>
            </defs>
            <line className="cls-1" x1="30.78" y1="134.77" x2="154.58" y2="134.77"></line>
            <polyline className="cls-1" points="65.69 137.89 65.69 147.17 45.89 147.17 45.89 137.89"></polyline>
            <polyline className="cls-1" points="142.58 137.89 142.58 147.17 122.78 147.17 122.78 137.89"></polyline>
            <polyline className="cls-2" points="106.63 120.53 106.63 99.36 148.44 99.36 148.44 120.53"></polyline>
            <polyline className="cls-2" points="64.81 120.53 64.81 99.36 106.63 99.36 106.63 120.53"></polyline>
            <polyline className="cls-2" points="86.54 84.39 86.54 64.22 128.35 64.22 128.35 84.39"></polyline>
            <path className="cls-1" d="M27.24,71.83,37.13,86a2.5,2.5,0,0,0,4.09,0l9.9-14.13"></path>
            <line className="cls-1" x1="39.18" y1="58.12" x2="39.18" y2="81.98"></line>
        </svg>
    )
}
